// extracted by mini-css-extract-plugin
module.exports = {"downArrow":"ArrowDown_downArrow__11K9w"};